// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"115":"7bdfc2c2","547":"8cc1e90f"}[chunkId] + ".chunk.js";
};